import { useGetTemplateById, useSaveTemplate } from "@/api/template.api";
import { useNavigate, useParams } from "react-router";
import { TemplateEditorCanvas } from "../template-editor-v2/template-editor-canvas";
import { TemplateEditorV2Slideshow } from "../template-editor-v2-slideshow/template-editor-v2-slideshow";
import { TemplateDto } from "@exibra/shared";

export const EditTemplate = () => {
    const { templateId } = useParams();
    const { data: template } = useGetTemplateById(templateId ? Number(templateId) : undefined);
    const { mutateAsync: saveTemplate } = useSaveTemplate();
    const navigate = useNavigate();

    const onSave = async (toSave: TemplateDto) => {
        await saveTemplate({ template: toSave, isCreate: false });
        navigate("..");
    };

    if (!template) {
        return null;
    }

    if (template.version === 2) {
        return (
            <TemplateEditorV2Slideshow
                template={template}
                onSave={onSave}
                key={`${template.id}-${template.updatedAt}`}
            />
        );
    }

    return (
        <TemplateEditorCanvas
            template={template}
            onSave={onSave}
            key={`${template.id}-${template.updatedAt}`}
        />
    );
};
